/*
This component implements the "footer" (side rail) links for the signed in
desktop home page. It essentially duplicates _footer_responsive.html.haml,
which is (going to be) used everywhere else. I (clinew) decided it was not
worth the time and effort to engineer a single component, with a single set of
markup, that could be used in both places, because the styling is so different.
*/
import React from "react";
import GrComponentFactory from "../gr_component_factory";
import classNames from "classnames";
import { getImages } from "../../modules/shared/image_registry";

export default GrComponentFactory.createClass({
  displayName: "Footer",

  propTypes: {
    aboutUrl: React.PropTypes.string.isRequired,
    adPreferencesUrl: React.PropTypes.string.isRequired,
    androidDownloadUrl: React.PropTypes.string.isRequired,
    authorsUrl: React.PropTypes.string.isRequired,
    authorsBlogUrl: React.PropTypes.string.isRequired,
    yourAdsPrivacyChoicesUrl: React.PropTypes.string.isRequired,
    facebookUrl: React.PropTypes.string.isRequired,
    instagramUrl: React.PropTypes.string.isRequired,
    interestBasedAdsUrl: React.PropTypes.string.isRequired,
    iOSDownloadUrl: React.PropTypes.string.isRequired,
    jobsUrl: React.PropTypes.string.isRequired,
    linkedInUrl: React.PropTypes.string.isRequired,
    advertiseUrl: React.PropTypes.string.isRequired,
    termsUrl: React.PropTypes.string.isRequired,
    twitterUrl: React.PropTypes.string.isRequired,
    privacyUrl: React.PropTypes.string.isRequired,
    helpUrl: React.PropTypes.string.isRequired,
    mobileSiteUrl: React.PropTypes.string.isRequired,
    // TODO: https://issues.amazon.com/issues/CaR-9319: Clean up after fully launching CCBA pref page
    showCCBAPageLink: React.PropTypes.bool.isRequired,
  },

  render() {
    const siteLinkClasses = classNames("gr-hyperlink",
                                     "gr-hyperlink--black");
    return(
      <footer>
        <div className="gr-footer__siteLinks">
          <div className="gr-footer__firstLinkColumn">
            <h3 className="gr-h3">Company</h3>
            <div><a className={siteLinkClasses} href={this.props.aboutUrl}>About us</a></div>
            <div><a className={siteLinkClasses} href={this.props.jobsUrl}>Careers</a></div>
            <div><a className={siteLinkClasses} href={this.props.termsUrl}>Terms</a></div>
            <div><a className={siteLinkClasses} href={this.props.privacyUrl}>Privacy</a></div>
            <div><a className={siteLinkClasses} href={this.props.interestBasedAdsUrl}>Interest Based Ads</a></div>
            <div><a className={siteLinkClasses} href={this.props.adPreferencesUrl}>Ad Preferences</a></div>
              {/*TODO: https://issues.amazon.com/issues/CaR-9319: Clean up after fully launching CCBA pref page*/}
              {this.props.showCCBAPageLink &&
                <div>
                    <a className={siteLinkClasses} href={this.props.yourAdsPrivacyChoicesUrl} style={{whiteSpace: 'nowrap'}}>
                      Your Ads Privacy Choices
                      <img alt="" src={getImages().siteFooter.ccbaIcon} style={{marginLeft: '4px'}} />
                    </a>
                </div>
              }
            <div><a className={siteLinkClasses} href={this.props.helpUrl}>Help</a></div>
          </div>
          <div className="gr-footer__secondLinkColumn">
            <h3 className="gr-h3">Work with us</h3>
            <div><a className={siteLinkClasses} href={this.props.authorsUrl}>Authors</a></div>
            <div><a className={siteLinkClasses} href={this.props.advertiseUrl}>Advertise</a></div>
            <div><a className={siteLinkClasses} href={this.props.authorsBlogUrl}>Authors & ads blog</a></div>
          </div>
        </div>

        <h3 className="gr-h3">Connect</h3>
        <a className="gr-footer__socialLink" href={this.props.facebookUrl}>
          <img alt="Goodreads on Facebook" src={getImages().siteFooter.facebookIcon} />
        </a>
        <a className="gr-footer__socialLink" href={this.props.twitterUrl}>
          <img alt="Goodreads on Twitter" src={getImages().siteFooter.twitterIcon} />
        </a>
        <a className="gr-footer__socialLink" href={this.props.instagramUrl}>
          <img alt="Goodreads on Instagram" src={getImages().siteFooter.instagramIcon} />
        </a>
        <a className="gr-footer__socialLink" href={this.props.linkedInUrl}>
          <img alt="Goodreads on LinkedIn" src={getImages().siteFooter.linkedInIcon} />
        </a>

        <div className="gr-footer__appLinks">
          <a className="gr-footer__iOSLink" href={this.props.iOSDownloadUrl}>
            <img alt="Download app for iOS" src={getImages().goodreadsApps.iOSDownloadBadge} />
          </a>
          <a href={this.props.androidDownloadUrl}>
            <img alt="Download app for Android"
                 src={getImages().goodreadsApps.androidDownloadBadgeDesktopHome}
                 srcSet={`${getImages().goodreadsApps.androidDownloadBadgeDesktopHome2x} 2x`} />
          </a>
          <p>
            <a className="gr-hyperlink
                          gr-hyperlink--black
                          gr-footer__layoutLink
                          gr-footer__layoutLink--mobile"
              rel="nofollow"
              href={this.props.mobileSiteUrl}>Mobile Version</a>
          </p>

          <p>
            <small>© {new Date().getFullYear()} Goodreads LLC</small>
          </p>
          <img
            alt="An Amazon Company"
            src={getImages().siteFooter.amazonCompanyLogoIcon}
            style={{height: '1em', width: 'auto', display: 'block'}}
          />
        </div>
      </footer>
    );
  },
});
